import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

import type { Instructor } from '../modal/instructor';

export interface EditInstructorParams {
  fieldId: string;
  fieldName: string;
}

export const updateInstructorAPI = async ({
  fieldId,
  fieldName,
}: EditInstructorParams) => {
  const resp = await baseAPI.patch<Instructor>(`/custom-form/${fieldId}`, {
    fieldName,
    fieldId,
    fieldType: 'instructor',
  });
  return resp.data;
};

export const useUpdateInstructorMutation = () => {
  return useMutation({
    mutationFn: async (params: EditInstructorParams) => {
      const response = await updateInstructorAPI(params);
      return response;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.INSTRUCTORS,
      });
    },
  });
};
